<template>
  <div class="boletos container-fluid d-flex flex-column mt-3">
    <SimuladorStep v-if="step" :step="step" :valor="plano.valorMensal"
      :periodicidade="plano.modeloCobranca.periodicidade">
    </SimuladorStep>

    <div class="row h-100 justify-content-center" v-if="boleto && boleto.statusRegistro !== 'CANCELADO'">
      <div class="col flex-column h-100 text-center p-4 d-flex" :class="colSize ? 'col-12' : 'col-xl-5 col-lg-8 col-md-12 col-md-12'">
        <div >
          <div class="px-5 pb-4">
            Você tem 5 dias para pagar este boleto antes do vencimento.
          </div>
          <div @click="copiarCodigo" class="card p-2">
            <div v-if="copiaSucesso" class="sucesso">
              Código do Boleto Copiado
            </div>
            <strong class="border-bottom pb-2 mb-3">Copiar Linha Digitável</strong>
            <small>
              {{ mascaraBoleto(linhaDigitavel) }}
            </small>
            <input style="opacity: 0; height: 0" id="codigoBarraBoleto" :value="linhaDigitavel" />
          </div>
          <div class="my-3">
            <div class="d-flex justify-content-between">
              <span>Vencimento</span><strong>{{ dataVencimento }}</strong>
            </div>
            <div class="d-flex justify-content-between">
              <span>Valor do depósito:</span><strong>R$ {{ formatPrice(boleto ? boleto.valorBoleto : 0) }}</strong>
            </div>
            <div class="d-flex justify-content-between">
              <span>Cobrança:</span><strong>{{ detailRecorrencia ? detailRecorrencia.periodicidadeTipo : ''
              }}</strong>
            </div>
          </div>
          <div class="card aviso px-3 d-block py-2 border-0">
            <span v-if="origem === 'ASSINATURA'">Sua assinatura foi criada com sucesso e o boleto para pagamento está disponível. Após o processamento
              do pagamento sua assinatura será ativada.</span>
            <span v-if="origem === 'MARKETPLACE'">Seu pedido foi criado com sucesso e o boleto para pagamento está disponível. O pedido será processado após o pagamento do boleto.</span>
          </div>
        </div>

        <div v-if="erroBoleto" class="card my-5 badge-danger text-center p-3 text-uppercase">
          {{ erroBoleto.title }}
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card aviso px-3 d-block py-2 border-0">
          <div class="text-center">
            <b> Instruções para realizar o pagamento. </b>
            <br />
            <br />
            <span> 
              Para finalizar o pedido selecione uma forma de pagamento e realize o pagamento.
            </span>
          </div>
        </div>
    </div>
    <div class="row justify-content-center">
      <div class="mt-3 mb-5 px-3 col d-flex flex-column flex-lg-row justify-content-between" :class="colSize ? 'col-12' : 'col-xl-5 col-lg-8 col-md-12 col-md-12'">
        <button class="btn btn_color_system px-5 mt-4 py-2" @click="$router.go(-1)" v-if="!tipo">
          VOLTAR
        </button>
      
        <button class="btn btn_color_system py-2 mt-4" type="button" @click="baixarPdf()" v-if="boleto && boleto.statusRegistro !== 'CANCELADO'">
          BAIXAR BOLETO
        </button>

        <button class="btn btn_color_system mt-4 py-2" :class="colSize ? 'col-12': ''" type="button" @click="alterarFormaPagamento()" v-if="tipo">
          ALTERAR FORMA PAGAMENTO
        </button>
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </div>
</template>
<script>
import { APIService } from "../../APIService";
const apiService = new APIService();
import Loading from "@/components/Loading.vue";
import SimuladorStep from "@/components/assinaturas/SimuladorStep.vue";
import moment from "moment";

export default {
  name: "StepBoletos",
  props: ["idAssinatura", "idPlanoAssinatura", "boletoId", "pedidoId", "tipo", "colSize"],
  data() {
    return {
      loading: true,
      copiaSucesso: false,
      linhaDigitavel: "00000000000000000000000000000000000000000000000000000",
      urlPdf: null,
      dataVencimento: null,
      erroBoleto: null,
      boleto: null,
      detailRecorrencia: null,
      planoId: null,
      assinaturaId: null,
      plano: this.$store.state.simulacaoPlano,
      step: this.$route.query.step,
      origem: 'ASSINATURA'
    };
  },
  components: {
    Loading,
    SimuladorStep
  },
  created() {
    if(this.tipo === 'marketplace' || this.$route.params.tipo === 'marketplace') {
      if(this.$route.params.tipo === 'marketplace') {
        this.pedidoId = this.$route.params.pedidoId;
        this.boletoId = this.$route.params.boletoId;
      }
      
       this.origem = 'MARKETPLACE';
       this.obterBoletoPedidoMarketPlace(this.pedidoId, this.boletoId);
    }
    else {
      if (!this.idAssinatura) {
        this.planoId = this.$route.params.planoId;
      } else {
        this.planoId = this.idAssinatura;
      }
      if (!this.idPlanoAssinatura) {
        this.assinaturaId = this.$route.params.assinaturaId;
      } else {
        this.assinaturaId = this.idPlanoAssinatura;
      }

      this.obterBoletoAssinatura();

      if (this.assinaturaId > 0) {
        this.obterAssinatura();
      } else {
        this.loading = false;
      }
    }  
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    copiarCodigo() {
      document.getElementById("codigoBarraBoleto").select();
      document.execCommand("copy");
      this.copiaSucesso = true;
      setTimeout(() => {
        this.copiaSucesso = false;
      }, 800);
    },
    mascaraBoleto(data) {
      const numeroBoleto = [
        data.slice(0, 5),
        ".",
        data.slice(5, 10),
        " ",
        data.slice(10, 15),
        ".",
        data.slice(15, 21),
        " ",
        data.slice(21, 26),
        ".",
        data.slice(26, 32),
        " ",
        data.slice(32, 33),
        " ",
        data.slice(33),
      ];
      return numeroBoleto.join("");
    },
    goToStep(value) {
      if (value === 'assinaturas') {
        this.$router.push(`/assinaturas`);
      } else {
        this.$router.push(`/assinatura-detalhes/${this.idAssinatura}`);
        this.$emit("goToStep", value);
      }
    },
    baixarPdf() {
      window.open(this.urlPdf, '_blank');
    },
    obterBoletoPedidoMarketPlace(pedidoId) {
      apiService
      .obterBoletoByPedido(pedidoId)
      .then((res) => {
        this.boleto = res;
        this.linhaDigitavel = this.boleto.linhaDigitavel;
        this.btnloading = false;
        this.urlPdf = res.urlPdf;
        this.dataVencimento = this.boleto.dataVencimento
          ? moment(this.boleto.dataVencimento).format("MM/DD/yyyy")
          : null;
      })
      .catch((error) => (this.erroBoleto = error.response.data))
      .finally(() => (this.loading = false));
    },
    obterBoletoAssinatura() {
      apiService
      .obterBoletoPagamentoRecorrente(this.assinaturaId)
      .then((res) => {

        this.boleto = res;
        this.linhaDigitavel = this.boleto.linhaDigitavel;
        this.btnloading = false;
        this.urlPdf = res.urlPdf;
        this.dataVencimento = this.boleto.dataVencimento
          ? moment(this.boleto.dataVencimento).format("MM/DD/yyyy")
          : null;

          if(this.boleto && this.boleto.statusRegistro === 'CANCELADO') {
            this.colSize = undefined;
          }
      })
      .catch((error) => (this.erroBoleto = error.response.data))
      .finally(() => (this.loading = false));
    },
    obterAssinatura() {
      apiService
          .obterMinhaAssinaturaID(this.assinaturaId)
          .then((response) => {
            this.detailRecorrencia = response;
          });
    },
    alterarFormaPagamento() {
      if(this.tipo === 'marketplace') {
        this.$router.push(`/carrinho/${this.pedidoId}`);
      }
    }
  },
};
</script>
<style scoped lang="scss">
.card {
  border-radius: 10px;
  position: relative;

  &.aviso {
    background-color: #dfdfdf;
  }

  .sucesso {
    background-color: #a0d405;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    width: 100%;
    text-transform: uppercase;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
